const sellingPlans = () => `sellingPlanGroups(first: 1) {
  edges {
    node {
      appName
      name
      sellingPlans(first: 1) {
        edges {
          node {
            id
            name
            recurringDeliveries
          }
        }
      }
    }
  }
}`

const bundleProduct = (handle: string, plans = false) => `product(handle: "${ handle }") {
  id
  handle
  title
  ${ plans ? sellingPlans() : '' }
  variants(first: 3, reverse: true) {
    edges {
      node {
        id
        sku
        title
        price {
          currencyCode
          amount
        }
      }
    }
  }
}`

export const getBundleProducts = `query getBundleProducts($locale: LanguageCode!) @inContext(country: US, language: $locale) {
  onetime: ${ bundleProduct('custom-bundle') }
  coffeeOnetime: ${ bundleProduct('coffee-bundle-promo') }
  subscription: ${ bundleProduct('custom-bundle-subscription', true) }
  coffeeSubscription: ${ bundleProduct('coffee-bundle-subscription', true) }
}`

